export default "__VITE_ASSET__B7D4mK4D__"